import React from 'react';
import { Card, Layout } from 'antd';
import { CarryOutOutlined, SafetyOutlined, TrophyOutlined, BookOutlined } from '@ant-design/icons';
import { Routes } from '../../../routes';
import { PageLinkCard } from '../../../components/pageLinkCard/PageLinkCard';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { useFeatureFlags } from '../../../featureFlags';
import { flags } from '../../../featureFlags/flags';

const GamificationNav = () => {

    const breadcrumbs = [
        { name: 'Course Studio', path: Routes.Home.buildPath() },
        { name: 'Incentives' }
    ];

    const [ showObjectives, showLeaderboards, showBadges, showCertificates ] =
        useFeatureFlags( [ flags.OBJECTIVES, flags.LEADERBOARDS, flags.BADGES, flags.CERTIFICATES ] );

    return ( 
        <Layout className="user-stats-nav-page">
            
            { /* Page header breadcrumbs */ }
            <Breadcrumbs crumbs={ breadcrumbs }/>

                <Card
                    className="user-stats-content link-card"
                    title="Incentives"
                >

                    <PageLinkCard
                        disabled={ !showObjectives }
                        href={ Routes.ObjectivesPage.buildPath() }
                        icon={ <CarryOutOutlined />  }
                        title="Objectives"
                        description="Create and manage objectives for your users"
                    />

                    <PageLinkCard
                        disabled={ !showLeaderboards }
                        href={ Routes.ViewLeaderboardsPage.buildPath() }
                        icon={ <TrophyOutlined />  }
                        title="Leaderboards"
                        description="Make users compete for top learner"
                    />

                    <PageLinkCard
                        disabled={ !showBadges }
                        href={ Routes.ViewBadgesPage.buildPath() }
                        icon={ <SafetyOutlined />  }
                        title="Badges"
                        description="Award users for their accomplishments"
                    />

                    <PageLinkCard
                        disabled={ !showCertificates }
                        href={ Routes.ListCertificates.buildPath() }
                        icon={ <BookOutlined />  }
                        title="Certificates"
                        description="Create and edit certificates"
                    />

                </Card>
        </Layout>
    );
};

export default GamificationNav;